import React from 'react';
import {TouchableOpacityProps} from 'react-native';

import {Badge} from '../../../Interface/Badges/Badge';

import {ProductDTO} from '../../../../dtos/ProductDTO';

import {
  Container,
  Header,
  Info,
  ProductInfos,
  Photo,
  Title,
  RegularPrice,
  Price,
  PriceContainer,
  RegulaPriceSpot,
  NormalPrice,
  LineThrough,
  NormalPriceContainer,
} from './styles';
import {useTheme} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

interface Props extends TouchableOpacityProps {
  data: ProductDTO;
  productType: string;
}

export function ShoppingItem({data, productType, ...rest}: Props) {
  const theme = useTheme();

  const regularPrice = data.regularPrice;

  const hasDiscount = (data.price !== data.valorComDesconto);

  return (
    <Container {...rest}>
      <Header>
        <ProductInfos>
          <Photo source={{uri: data.imageUrl}} />
          <Info>
            <Title>
              {data.name.charAt(0).toUpperCase() + data.name.slice(1)}
            </Title>
            {productType === 'C' ? (
              <RegularPrice>
                Preço por{' '}
                {data.unidade.charAt(data.unidade.length - 1) === 's'
                  ? data.unidade
                      .toLowerCase()
                      .substring(0, data.unidade.length - 1)
                  : data.unidade.toLowerCase()}
                :
              </RegularPrice>
            ) : (
              regularPrice && (
                <RegularPrice>
                  De <RegulaPriceSpot>{regularPrice}</RegulaPriceSpot> por:
                </RegularPrice>
              )
            )}

            <PriceContainer>
              <Price>{hasDiscount ? data.valorComDesconto  : data.price}</Price>
              {hasDiscount && (
                <NormalPriceContainer>
                  <NormalPrice>{data.price}</NormalPrice>
                  <LineThrough />
                </NormalPriceContainer>
              )}
              {productType === 'C' && (
                <Badge
                  text={
                    data.unidade.charAt(data.unidade.length - 1) === 's'
                      ? data.unidade.substring(0, data.unidade.length - 1)
                      : data.unidade
                  }
                  containerStyle={{
                    backgroundColor: theme.colors.primary,
                    borderColor: theme.colors.primary,
                    marginLeft: RFValue(6),
                  }}
                  textStyle={{color: theme.colors.shape}}
                />
              )}
            </PriceContainer>
          </Info>
        </ProductInfos>
      </Header>
    </Container>
  );
}
